interface EpisodeSelectProps {
  total: number;
  current: number;
  onChange: (episode: number) => void;
}

export default function EpisodeSelect({ total, current, onChange }: EpisodeSelectProps) {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-list-check-2 text-primary-500"></i>
          选集
        </h3>
        <span className="text-xs text-foreground-500">
          更新至第 {total} 集 · 当前第 {current} 集
        </span>
      </div>
      <div className="hs-scrollbar-hide mt-4 max-h-44 overflow-y-auto">
        <div className="grid grid-cols-5 gap-2 sm:grid-cols-8 md:grid-cols-10">
          {Array.from({ length: total }, (_, i) => i + 1).map((episode) => {
            const active = episode === current;
            return (
              <button
                key={episode}
                type="button"
                onClick={() => onChange(episode)}
                className={`h-9 cursor-pointer rounded-md text-sm transition-colors ${
                  active
                    ? 'bg-primary-500 font-semibold text-background-50'
                    : 'bg-background-200/70 text-foreground-700 hover:bg-background-300 hover:text-foreground-950'
                }`}
              >
                {episode}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}